const stats = [
  { value: '10K+', label: 'Curated Finds' },
  { value: '50+', label: 'Categories & Subcategories' },
];

const reviews = [
  {
    name: 'Marcus T.',
    handle: '@marcus_finds',
    text: 'Finally a resource that actually organizes everything. The Superbuy Spreadsheet guide saved me hours of searching through random products. Highly recommended for anyone getting started.',
    avatarBg: 'bg-primary-100',
    avatarText: 'text-primary-600',
    initials: 'MT',
  },
  {
    name: 'Sophie L.',
    handle: '@sophie_shop',
    text: 'I was skeptical at first but the category breakdown is incredibly useful. Found some amazing sneaker deals through the Shoes section that I would have never discovered on my own.',
    avatarBg: 'bg-accent-100',
    avatarText: 'text-accent-600',
    initials: 'SL',
  },
  {
    name: 'James K.',
    handle: '@james_streetwear',
    text: 'The quality check guide alone is worth bookmarking this site. As someone new to international shopping, the safety tips gave me confidence to place my first orders.',
    avatarBg: 'bg-secondary-100',
    avatarText: 'text-secondary-600',
    initials: 'JK',
  },
  {
    name: 'Emily R.',
    handle: '@emily_style',
    text: 'This hub makes product comparison so effortless. The comparison tables in the guide helped me pick the right sellers. The weekly updates keep things fresh too.',
    avatarBg: 'bg-primary-100',
    avatarText: 'text-primary-600',
    initials: 'ER',
  },
  {
    name: 'David W.',
    handle: '@david_deals',
    text: 'The best Superbuy Spreadsheet resource I have found. Clean layout, easy navigation, and the beginner tutorial got me up to speed in under 10 minutes. Brilliant work.',
    avatarBg: 'bg-accent-100',
    avatarText: 'text-accent-600',
    initials: 'DW',
  },
  {
    name: 'Lena H.',
    handle: '@lena_fashion',
    text: 'I love how all the categories link directly to the main platform. It is like having a curated shopping assistant. The Hoodies section is my personal favorite.',
    avatarBg: 'bg-secondary-100',
    avatarText: 'text-secondary-600',
    initials: 'LH',
  },
];

export default function TrustSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* About Section */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-16">
          {/* Left: Text */}
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 rounded-full border border-background-300 text-foreground-600 text-xs font-medium tracking-wide mb-4">
              About The Hub
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight mb-2">
              Your Complete
            </h2>
            <p className="font-heading text-3xl md:text-4xl text-foreground-500 font-normal leading-tight mb-6">
              Shopping Intelligence Platform
            </p>
            <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
              <p>
                <strong>Superbuy Spread Hub</strong> is the most comprehensive independent resource dedicated to the Superbuy Spreadsheet ecosystem. We help global shoppers navigate thousands of curated product finds across 14 organized categories, from sneakers and streetwear to accessories and fragrances.
              </p>
              <p>
                Unlike random product lists scattered across forums and social media, our platform structures every discovery with detailed category breakdowns, quality check methodologies, and step-by-step buying guides. Whether you are a complete beginner learning how Superbuy Spreadsheet works or an experienced shopper looking for the latest trending finds, our resources are built to save you time and help you make smarter purchasing decisions.
              </p>
              <p>
                Our content is updated weekly to reflect the newest products, seasonal trends, and community feedback. Every category page links directly to the main Superbuy Spreadsheet platform so you can jump from research to purchase in a single click.
              </p>
            </div>
            <a href="/" className="inline-flex items-center gap-1.5 mt-6 text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors underline underline-offset-4">
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </a>
          </div>

          {/* Right: Stats + Images */}
          <div className="lg:w-3/5">
            <div className="flex items-start justify-end gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-right">
                  <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">{stat.value}</div>
                  <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Decorative Image Stack */}
            <div className="relative h-64 md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=Stacked%20denim%20jeans%20and%20colorful%20textured%20hoodies%20arranged%20in%20artistic%20flat%20lay%20on%20distressed%20wooden%20floor%2C%20warm%20natural%20sunlight%20from%20large%20window%2C%20rich%20indigo%20and%20terracotta%20and%20olive%20green%20tones%2C%20editorial%20catalog%20photography%20with%20deep%20shadows%20and%20texture%20emphasis%2C%20urban%20artisan%20workshop%20atmosphere%2C%20carefully%20curated%20casual%20fashion%20composition&width=600&height=800&seq=about-img-1-v2&orientation=portrait"
                alt="Superbuy Spreadsheet curated product collection"
                title="Curated Superbuy Spreadsheet Finds"
                className="absolute right-0 top-0 w-40 md:w-52 h-56 md:h-72 rounded-lg object-cover object-top z-10"
              />
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20leather%20wallet%20and%20watch%20and%20sunglasses%20displayed%20on%20slate%20gray%20stone%20surface%2C%20soft%20side%20lighting%20creating%20elegant%20reflections%2C%20bronze%20and%20brown%20and%20gunmetal%20accents%2C%20sophisticated%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20modern%20minimalist%20luxury%20boutique%20feel%2C%20crisp%20and%20refined%20composition&width=600&height=800&seq=about-img-2-v2&orientation=portrait"
                alt="Superbuy Spreadsheet fashion accessories"
                title="Superbuy Spreadsheet Accessories Collection"
                className="absolute right-32 md:right-40 top-8 w-44 md:w-56 h-52 md:h-64 rounded-lg object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Reviews */}
        <div>
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-4">
            Community Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-tight mb-10">
            Trusted by Global<br />Shoppers Worldwide
          </h2>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
            {reviews.map((review) => (
              <div key={review.handle} className="break-inside-avoid mb-5 rounded-lg bg-background-100 p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-full ${review.avatarBg} flex items-center justify-center shrink-0`}>
                    <span className={`text-sm font-semibold ${review.avatarText}`}>{review.initials}</span>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                    <div className="text-xs text-foreground-500">{review.handle}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{review.text}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}